export const ORGANIZATION_PLANS = [
  {
    id: "starter",
    name: "Starter",
    priceAnnual: 228,
    mailboxLimit: 10,
    domainLimit: 3,
    storageGb: 10,
    dailyDeliveryLimit: 400,
    maxRecipientsPerMessage: 100,
    maxOutboundAttachmentMb: 35,
  },
  {
    id: "growth",
    name: "Growth",
    priceAnnual: 948,
    mailboxLimit: 50,
    domainLimit: 10,
    storageGb: 50,
    dailyDeliveryLimit: 600,
    maxRecipientsPerMessage: 100,
    maxOutboundAttachmentMb: 35,
  },
  {
    id: "business",
    name: "Scale",
    priceAnnual: 1668,
    mailboxLimit: 100,
    domainLimit: 25,
    storageGb: 100,
    dailyDeliveryLimit: 800,
    maxRecipientsPerMessage: 100,
    maxOutboundAttachmentMb: 35,
  },
] as const;
